<div *ngIf="user" class="tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-white tw-border tw-border-[#E8E8E8] tw-rounded-[10px] md:tw-px-4 lg:tw-px-8">
  <form class="tw-w-full tw-h-fit tw-py-8 tw-px-4" [formGroup]="formGroup">
    <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-4 tw-mb-8">
      <p class="tw-flex-1 tw-font-poppins tw-font-bold tw-text-lg tw-text-secondary">
        {{ title | translate }}
      </p>
      <div (click)="closeModal()" class="tw-min-w-8 tw-min-h-8 tw-max-w-8 tw-max-h-8 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
        <img class="tw-w-5 tw-h-5 tw-object-contain" src="../../../assets/close-light-icon.svg" />
      </div>
    </div>
    <app-input [formGroup]="formGroup" formControlName="name" [label]="'name' | translate"></app-input>
    <app-input [formGroup]="formGroup" formControlName="description" [label]="'description' | translate"></app-input>
    <div *ngIf="user.user.business.type == accountTypes.Delivery" class="tw-w-full tw-h-fit">
      <div *ngIf="formGroup.get('own_product').value == 'external-product'" class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-mb-4">
        <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "business" | translate }}</p>
        <p-dropdown
          class="tw-w-full tw-h-fit tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
          [options]="businesses"
          [(ngModel)]="selectedBusiness"
          [ngModelOptions]="{ standalone: true }"
          dataKey="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          [placeholder]="'business' | translate"
          (onFilter)="searchBusinesses.next($event.filter)"
          [emptyFilterMessage]="searchBusinessesNoResults | translate"
          (onChange)="setBusiness($event)"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
            <div class="flex align-items-center gap-2">
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-item pTemplate="item">
            <div class="flex align-items-center gap-2">
              <div>{{ item.name }}</div>
            </div>
          </ng-template>
        </p-dropdown>
      </div>
    </div>
    <app-toggle
      [formGroup]="formGroup"
      formControlName="has_options"
      [label]="'has-options' | translate"
      [negative]="{ label: 'no', value: false }"
      [positive]="{ label: 'yes', value: true }"
    ></app-toggle>
    <app-input *ngIf="formGroup.get('has_options')?.value == false" [formGroup]="formGroup" formControlName="price" [label]="'price' | translate" type="number"></app-input>
    <div *ngIf="formGroup.get('has_options')?.value == true" class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-mb-4">
      <div class="tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-2">
        <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "product-options" | translate }}</p>
        <app-button [text]="'add-option' | translate" [fullWidth]="false" [onButtonClick]="addOption.bind(this)"></app-button>
      </div>
      <div class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-4 tw-mt-2">
        <div *ngFor="let optionForm of optionFormGroups; let i = index" class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-border tw-border-grey-600 tw-rounded-[5px] tw-p-3">
          <form [formGroup]="optionForm">
            <div class="tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-2">
              <p class="tw-flex-1 tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "option" | translate }} {{ i + 1 }}</p>
              <div (click)="deleteOption(i)" class="tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-danger tw-rounded-full tw-cursor-pointer">
                <img class="tw-w-4 tw-h-4 tw-object-contain" src="../../../assets/close-light-icon.svg" />
              </div>
            </div>
            <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-x-2 tw-mb-2">
              <app-input class="tw-flex-1 tw-max-w-full" [formGroup]="optionForm" formControlName="name" [label]="'option-name' | translate"></app-input>
              <div class="full-dropdown tw-w-full tw-h-fit tw-flex tw-flex-col tw-flex-1">
                <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">{{ "option-type" | translate }}</p>
                <p-dropdown
                  class="tw-w-full tw-h-fit tw-min-h-12 tw-relative tw-border tw-border-grey-600 tw-rounded-[5px]"
                  [options]="optionTypes"
                  formControlName="type"
                  [filter]="false"
                  [showClear]="false"
                  [placeholder]="'option-type' | translate"
                  (onChange)="setOptionType($event, optionForm)"
                >
                  <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">
                    <div class="flex align-items-center gap-2">
                      <div>{{ selectedOption | translate }}</div>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div>{{ item | translate }}</div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
            <div class="tw-w-full tw-h-fit tw-flex tw-items-center tw-gap-2">
              <app-toggle
                [formGroup]="optionForm"
                formControlName="required"
                [label]="'option-required' | translate"
                [negative]="{ label: 'no', value: false }"
                [positive]="{ label: 'yes', value: true }"
              ></app-toggle>
            </div>
            <div *ngIf="optionForm.get('type').value == 'select' || optionForm.get('type').value == 'multi-select'" class="tw-w-full tw-h-fit">
              <div class="tw-w-full tw-h-fit tw-flex tw-justify-between tw-items-center tw-flex-wrap tw-gap-2 tw-mb-2">
                <p class="tw-w-full tw-h-fit tw-font-poppins tw-font-medium tw-text-sm tw-text-secondary">{{ "choices" | translate }}</p>
                <app-button [text]="'add-choice' | translate" [fullWidth]="false" [onButtonClick]="addChoice.bind(this, optionForm)"></app-button>
              </div>
              <div class="tw-w-full tw-h-fit tw-mt-2">
                <div *ngFor="let choiceForm of optionForm.get('choices')?.value; let j = index" class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-gap-x-2">
                  <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="choiceForm" formControlName="name" [label]="'name' | translate" [widthLimited]="true"></app-input>
                  <app-input class="tw-flex-1 tw-max-w-full tw-min-w-0" [formGroup]="choiceForm" formControlName="price" [label]="'price' | translate" [widthLimited]="true" type="number"></app-input>

                  <div class="tw-w-fit tw-h-full tw-pt-8">
                    <div (click)="deleteChoice(optionForm, j)" class="tw-w-6 tw-h-6 tw-flex tw-justify-center tw-items-center tw-bg-danger tw-rounded-full tw-cursor-pointer">
                      <img class="tw-w-4 tw-h-4 tw-object-contain" src="../../../assets/close-light-icon.svg" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="optionForm.get('type').value == 'number'" class="tw-w-full tw-h-fit tw-flex tw-flex-col tw-gap-2 tw-mt-2">
              <app-input [formGroup]="optionForm" formControlName="price" [label]="'price' | translate" type="number"></app-input>
            </div>
          </form>
        </div>
      </div>
    </div>

    <app-input [formGroup]="formGroup" formControlName="category" [label]="'category' | translate"></app-input>
    <div class="tw-w-full tw-mb-4">
      <app-input [formGroup]="formGroup" formControlName="ingredient" [label]="'ingredients' | translate" (keydown)="addIngredient($event)"></app-input>

      <div class="tw-flex tw-flex-wrap tw-gap-2 -tw-mt-2">
        <div *ngFor="let ingredient of ingredients; let i = index" class="tw-flex tw-items-center tw-gap-2 tw-bg-grey-100 tw-px-3 tw-py-1 tw-rounded-full">
          <span class="tw-font-poppins tw-text-sm tw-text-secondary">{{ ingredient }}</span>
          <div (click)="removeIngredient(i)" class="tw-w-4 tw-h-4 tw-flex tw-justify-center tw-items-center tw-bg-secondary tw-rounded-full tw-cursor-pointer">
            <img class="tw-w-2 tw-h-2 tw-object-contain" src="../../../assets/close-light-icon.svg" />
          </div>
        </div>
      </div>
    </div>

    <app-image-picker [formGroup]="formGroup" formControlName="file" imageFormControlName="imageURL" [label]="'upload-new-image' | translate"></app-image-picker>
    <app-toggle
      [formGroup]="formGroup"
      formControlName="published"
      [label]="'published' | translate"
      [negative]="{ label: 'no', value: false }"
      [positive]="{ label: 'yes', value: true }"
    ></app-toggle>

    <div class="tw-w-full tw-h-2"></div>
    <app-button [disabled]="disableButton" [text]="'save' | translate" [fullWidth]="true" [onButtonClick]="buttonClicked.bind(this)"></app-button>
  </form>
</div>
